import { c as _c } from "react/compiler-runtime";
export const BaggageIcon = t0 => {
  const $ = _c(13);
  const {
    selected
  } = t0;
  const strokeColor = selected ? "#EFFCF8" : "#008254";
  const t1 = selected ? "#008254" : "#EFFCF8";
  let t2;
  if ($[0] !== t1) {
    t2 = <rect x="0.571533" width="40" height="40" rx="20" fill={t1} />;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[2] !== strokeColor) {
    t3 = <path d="M26.1715 13.9922H14.9715C14.1983 13.9922 13.5715 14.8876 13.5715 15.9922V25.9922C13.5715 27.0968 14.1983 27.9922 14.9715 27.9922H26.1715C26.9447 27.9922 27.5715 27.0968 27.5715 25.9922V15.9922C27.5715 14.8876 26.9447 13.9922 26.1715 13.9922Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t4 = <path d="M23.5715 27.9922V11.9922C23.5715 11.4618 23.4135 10.953 23.1322 10.578C22.8509 10.2029 22.4694 9.99219 22.0715 9.99219H19.0715C18.6737 9.99219 18.2922 10.2029 18.0109 10.578C17.7296 10.953 17.5715 11.4618 17.5715 11.9922V27.9922" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t5 = <path d="M15.5762 29.9922L15.5762 28.4462" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    t6 = <path d="M25.575 30.0078L25.575 28.4618" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = strokeColor;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t2 || $[8] !== t3 || $[9] !== t4 || $[10] !== t5 || $[11] !== t6) {
    t7 = <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">{t2}{t3}{t4}{t5}{t6}</svg>;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};